var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecretary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Secretary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5088.87,5402.85a107.49,107.49,0,1,0-107.52,107.52A107.52,107.52,0,0,0,5088.87,5402.85Z",
    transform: "translate(-4873.89 -5295.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4981.35,5494.37a107.48,107.48,0,0,1-107.16-99.52q-.3,4-.3,8a107.49,107.49,0,1,0,215,0q0-4-.3-8A107.54,107.54,0,0,1,4981.35,5494.37Z",
    transform: "translate(-4873.89 -5295.39)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4981.35,5311.39a107.52,107.52,0,0,1,107.22,99.46q.3-4,.3-8a107.49,107.49,0,0,0-215,0q0,4,.3,8A107.47,107.47,0,0,1,4981.35,5311.39Z",
    transform: "translate(-4873.89 -5295.39)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5050.56,5384.63a5,5,0,0,1-5-5,47,47,0,0,0-46.9-46.9,5,5,0,1,1,0-10,57,57,0,0,1,56.94,56.93,5,5,0,0,1-5,5",
    transform: "translate(-4873.89 -5295.39)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4970.12,5465.08a5,5,0,0,1-5-5,47,47,0,0,0-46.9-46.9,5,5,0,1,1,0-10,57,57,0,0,1,56.93,56.94,5,5,0,0,1-5,5",
    transform: "translate(-4873.89 -5295.39)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4970.12,5465.08a5,5,0,0,1-3.56-8.57l80.45-80.45a5,5,0,0,1,7.1,7.1l-80.45,80.45a5,5,0,0,1-3.54,1.47",
    transform: "translate(-4873.89 -5295.39)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4970.12,5465.08H4918.2a5,5,0,0,1-5-5v-51.92a5,5,0,0,1,10,0V5455h46.9a5,5,0,0,1,0,10",
    transform: "translate(-4873.89 -5295.39)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4998.64,5332.71a5,5,0,0,1-3.54-8.57h0l-80.45,80.44a5,5,0,0,0,7.1,7.1l78.92-78.92c-.67,0-1.35-.06-2-.06",
    transform: "translate(-4873.89 -5295.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretary);
export default __webpack_public_path__ + "static/media/Secretary.139c276def71f77c350725da3382f1e4.svg";
export { ForwardRef as ReactComponent };